export const API_URL = process.env.REACT_APP_API_URL;
export const IAM_URL = process.env.REACT_APP_IAM_URL;
export const IAM_REALM = process.env.REACT_APP_IAM_REALM;
export const IAM_CLIENT_ID = process.env.REACT_APP_IAM_CLIENT_ID;
export const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL;
